import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-100 px-4 md:px-6 lg:px-8 pt-14 pb-8">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-50 rounded-2xl px-8 md:px-12 py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
            <div className="md:col-span-5">
              <Link to="/" className="inline-block mb-4">
                <span className="font-heading text-2xl font-black text-primary-600 tracking-tight">
                  吃瓜网
                </span>
              </Link>
              <p className="text-foreground-600 text-sm leading-relaxed max-w-sm">
                吃瓜网站汇聚吃瓜网每日大赛与实时吃瓜爆料平台，全网最全黑料、独家八卦持续更新。免费吃瓜第一站，网红大瓜正能量不打烊。明星八卦、网红黑料、社会热点一网打尽，做你最靠谱的吃瓜伙伴。
              </p>
              <div className="flex items-center gap-3 mt-6">
                <a href="http://claekqe.cn/" target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="http://claekqe.cn/" target="_blank" rel="nofollow noopener" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="知乎">
                  <i className="ri-zhihu-line text-lg"></i>
                </a>
              </div>
            </div>

            <div className="md:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950 uppercase tracking-wider mb-4">
                快速导航
              </h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors">
                    关于我们
                  </Link>
                </li>
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="font-heading text-sm font-bold text-foreground-950 uppercase tracking-wider mb-4">
                热门分类
              </h4>
              <ul className="space-y-3">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-foreground-600 hover:text-foreground-950 text-sm transition-colors"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950 uppercase tracking-wider mb-4">
                联系方式
              </h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-2 text-foreground-600 text-sm">
                  <i className="ri-mail-line text-base"></i>
                  <span>hello@claekqe.cn</span>
                </li>
                <li className="flex items-center gap-2 text-foreground-600 text-sm">
                  <i className="ri-phone-line text-base"></i>
                  <span>400-888-6666</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-foreground-500 text-xs">
                &copy; {currentYear} 吃瓜网 All Rights Reserved.
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <Link to="/" className="hover:text-foreground-800 transition-colors">隐私政策</Link>
                <span className="text-foreground-300">|</span>
                <Link to="/" className="hover:text-foreground-800 transition-colors">用户协议</Link>
                <span className="text-foreground-300">|</span>
                <Link to="/" className="hover:text-foreground-800 transition-colors">免责声明</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
